import { http } from "../../utils";

export async function loginAdmin(formData) {
  return http("/auth/login/admin", {
    data: {
      username: formData.username,
      password: formData.password,
    },
  });
}
